module.exports = __webpack_public_path__ + "img/hr-start-end-integration-patches.07a5766a.png";